import React from "react";
import { View, Text, TextInput, Button } from "ui";
import { User } from "types";
import moment from "moment";
import { NavLink } from "react-router-dom";
import { subscriptionMutations } from "api";
import { Modal } from "@material-ui/core";
import styled from "styled-components";
import { notify } from "../shared/services/notify";
import { RouteComponentProps } from 'react-router';

interface P {
  currentUser: User;
}

const SUBSCRIPTION_LABELS = {
  trial: "Trial",
  yearly: "Platit",
  code: "Voucher"
};

export default class UserPage extends React.Component<P & RouteComponentProps<any>> {
  public state = {
    code: "",
    paymentSuccess: this.props.location.search ==='?payment',
  };

  public handleClose = () => {
    this.setState({ openCodeModal: false, code: "" });
  }
  public handleCodeChange = e => {
    this.setState({ code: e.target.value });
  }
  public render = () => {
    const { code } = this.state;
    const currentUser = this.props.currentUser;
    let endsAt;
    let type;

    // change bellow after new currentUser

    if (currentUser.subscribed) {
      endsAt = moment(currentUser.subscription.endsAt).format("DD MMM YYYY");
      type = SUBSCRIPTION_LABELS[currentUser.subscription.braintreePlan];
    } else {
      endsAt = "-";
      type = "-";
    }

    const SubscriptionDetails = [
      {
        title: "Tipul Abonamentului:",
        content: type
      },
      {
        title: "Valabil pana la data:",
        content: endsAt
      }
    ];

    const hasPayment =
      !currentUser.subscribed ||
      (currentUser.subscription &&
        currentUser.subscription.braintreePlan === "trial");
    const hasVoucher =
      currentUser.subscription &&
      currentUser.subscription.braintreePlan === "code";
    return (
      <View mt={1} flexDirection="column">
        <Text p={3} mt={1} fontSize={5} fontWeight="bold">
          Abonament
        </Text>
        <View p={3} flexDirection="column">
          {SubscriptionDetails.map(detailItem => (
            <View
              mb={2}
              flexDirection="row"
              alignItems="stretch"
              justifyContent="space-between"
            >
              <Text fontSize={4} mr={3}>
                {detailItem.title}
              </Text>
              <Text fontSize={3} fontWeight="bold">
                {detailItem.content}
              </Text>
            </View>
          ))}
          {(hasPayment || hasVoucher) && (
            <View
              mt={2}
              p={2}
              borderRadius="10px"
              border="1px solid black"
              flexDirection="column"
            >
              <Text mt={1} flex={1} fontSize={3}>
                Abonament anual{" "}&nbsp;
                <Text
                  style={{
                    display: "inline-block",
                    textDecoration: "line-through",
                    textDecorationColor: "red"
                  }}
                >
                  120
                </Text>{" "}
                &nbsp;60 lei/an
              </Text>
              <Button bg="primary" mt={3} as={NavLink} to="/app/cumpara">
                <Text color="white" fontSize={3}>
                  Plata card
                </Text>
              </Button>
            </View>
          )}
          {hasPayment && (
            <subscriptionMutations.SubscribeWithCode>
              {subscribeWithCode => (
                <form
                  onSubmit={async e => {
                    e.preventDefault();
                    try {
                      const res = await subscribeWithCode({
                        variables: { code: this.state.code }
                      });
                      const r = res;
                      if (!r || !r.data) {
                        return;
                      }
                      const subscriptionEndsAt =
                        r.data.subscribeByCode.subscription.endsAt;
                      const daysValid = moment(subscriptionEndsAt).diff(
                        moment(),
                        "d"
                      );
                      notify(
                        `Felicitari! Sunteti abonat pentru urmatoarele ${daysValid +
                          1} zile.`
                      );
                    } catch (err) {}
                  }}
                >
                  <View
                    mt={2}
                    p={2}
                    borderRadius="10px"
                    border="1px solid black"
                    flexDirection="column"
                  >
                    <TextInput
                      value={code}
                      onChange={this.handleCodeChange}
                      height="2rem"
                      fontSize={2}
                      placeholder="Cod voucher"
                    />
                    <Button
                      mt={2}
                      p={2}
                      bg="primary"
                      alignSelf="stretch"
                      as="button"
                      type="submit"
                      border="none"
                    >
                      <Text color="white" fontSize={3}>
                        Activeaza voucher
                      </Text>
                    </Button>
                  </View>
                </form>
              )}
            </subscriptionMutations.SubscribeWithCode>
          )}
          {this.state.paymentSuccess && (
            <View mt={4}>
              <Text fontSize={5}>Plata a fost realizata cu succes</Text>
            </View>
          )}
        </View>
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UserPage.tsx